<template>
  <div class="info-acao-container">
    <Carregamento v-if="carregando" />

    <div v-else class="info-acao-wrapper">
      <div class="info-titulo-secao">
        <h3>Informações da Ação</h3>
        <div class="botoes-topo">
          <button v-if="!modoEditar" type="button" class="btn-membros-equipe" @click="abrirModalMembros">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"
              aria-hidden="true">
              <path
                d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
            </svg>

            Ver membros da equipe
          </button>

          <button v-if="!modoEditar && isCoordenadorDaAcao" type="button" class="btn-editar-principal"
            @click="abrirFormularioParceria">
            <i class="fa-solid fa-handshake" aria-hidden="true"></i>

            Solicitar parceria
          </button>

          <button v-if="!modoEditar && isCoordenadorDaAcao" type="button" class="btn-editar-principal"
            @click="ativarModoEditar">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"
              aria-hidden="true">
              <path
                d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />

              <path fill-rule="evenodd"
                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
            </svg>

            Editar
          </button>
        </div>
      </div>

      <div class="info-form">
        <div class="campos-grid">
          <div class="coluna-esquerda">
            <div class="campo-grupo">
              <label class="campo-label">Imagem da Ação</label>

              <div v-show="modoEditar" class="input-imagem-container" style="margin-bottom: 12px">
                <input ref="inputImagem" type="file" class="imagem-upload-input-novo" accept="image/*"
                  title="Alterar imagem" @change="onImagemSelecionada" />
              </div>

              <div v-if="imagemAtual" class="imagem-preview-container">
                <img :src="imagemAtual" alt="Imagem da Ação" class="imagem-preview-img" />

                <button v-if="modoEditar" type="button" class="btn-excluir-foto" title="Remover imagem"
                  @click.prevent="removerImagem">
                  X
                </button>
              </div>

              <div v-if="!modoEditar && !imagemAtual" class="imagem-placeholder">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16"
                  aria-hidden="true">
                  <path
                    d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM10.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />

                  <path
                    d="M1 11.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-1.5v1.5a.5.5 0 0 1-1 0zm0 3v-1.5a.5.5 0 0 1 1 0V14h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm14-3v-1.5a.5.5 0 0 0-1 0V13h-1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5zm0 3v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0z" />
                </svg>

                <span>Sem imagem</span>
              </div>
            </div>
            <div class="campo-grupo">
              <label class="campo-label">Título</label>
              <p v-if="!modoEditar" class="campo-texto-leitura">
                {{ formData.titulo }}
              </p>

              <input v-else v-model="formData.titulo" type="text" class="campo-input" />
            </div>
            <div class="campo-grupo">
              <label class="campo-label">Sigla da Ação</label>

              <div class="campo-com-acao">
                <input type="text" class="campo-input" :value="acao.sigla || 'Sem sigla'"
                  :disabled="!modoEditar || !isCoordenadorDaAcao" :style="modoEditar && isCoordenadorDaAcao
                    ? 'cursor: pointer;'
                    : ''
                    " :title="modoEditar && isCoordenadorDaAcao
                      ? 'Clique para editar a sigla e cor'
                      : ''
                      " @click="
                        modoEditar && isCoordenadorDaAcao
                          ? abrirModalSigla()
                          : null
                        " />
              </div>
            </div>

            <div class="campo-grupo">
              <label class="campo-label">Área Temática</label>

              <input v-model="formData.areaTematica" type="text" class="campo-input" :disabled="!modoEditar"
                placeholder="Ex: TECNOLOGIA_E_PRODUCAO" />
            </div>

            <div class="campo-grupo">
              <label class="campo-label">Coordenador</label>

              <div class="campo-coordenador-container">
                <input type="text" class="campo-input input-coordenador" :value="acao.nomeCoordenador || '—'"
                  disabled />

                <button v-if="!isCoordenadorDaAcao && usuarioAutenticado" type="button" class="btn-falar-coordenador"
                  title="Falar com coordenador" @click="abrirModalFaleConosco">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"
                    aria-hidden="true">
                    <path
                      d="M16 8c0 3.866-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7M5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                  </svg>

                  <span>Falar com coordenador</span>
                </button>
              </div>
            </div>

            <div class="linha-datas">
              <div class="campo-grupo">
                <label class="campo-label">Data de Início</label>

                <input v-model="formData.dataInicio" type="date" class="campo-input" disabled />
              </div>

              <div class="campo-grupo">
                <label class="campo-label">Data de Fim</label>

                <input v-model="formData.dataFim" type="date" class="campo-input" disabled />
              </div>
            </div>

            <div class="campo-grupo parcerias-acao-secao">
              <div class="parcerias-acao-cabecalho">
                <label class="campo-label">
                  Parcerias
                </label>


              </div>

              <div v-if="carregandoParcerias" class="parcerias-acao-carregando">
                Carregando parcerias...
              </div>

              <div v-else-if="parcerias.length > 0" class="parcerias-acao-lista">
                <div v-for="parceria in parcerias" :key="parceria.id" class="parceria-acao-item">
                  <span class="parceria-acao-titulo">
                    {{ parceria.parceiro }}
                  </span>

                  <span :class="parceria.jaFormalizada === true
                    ? 'formalizada'
                    : 'nao-formalizada'">
                    {{ parceria.jaFormalizada === true
                      ? 'Formalizada'
                      : parceria.jaFormalizada === false
                        ? 'Não formalizada'
                        : 'Não informado' }}
                  </span>
                </div>
              </div>
              <p v-if="!carregandoParcerias && parcerias.length === 0" class="parcerias-acao-vazio">
                Nenhuma parceria cadastrada para esta ação.
              </p>
            </div>

          </div>
          <div class="coluna-direita">
            <div class="campo-grupo">
              <label class="campo-label">Descrição</label>

              <p v-if="!modoEditar && !formData.descricao?.trim()" class="descricao-vazia">
                Nenhuma descrição cadastrada
              </p>

              <textarea ref="textareaDescricao" v-model="formData.descricao" class="campo-input campo-textarea"
                :class="{ 'campo-textarea-leitura': !modoEditar }" :disabled="!modoEditar"
                @input="ajustarAlturaDescricao"></textarea>
            </div>
            <div class="campo-grupo">
              <label class="campo-label">
                Objetivos Específicos
              </label>

              <div v-if="modoEditar" class="objetivo-input-wrapper">
                <input v-model="novoObjetivo" type="text" class="campo-input objetivo-input"
                  placeholder="Digite um objetivo e pressione Enter" maxlength="200"
                  @keydown.enter.prevent="adicionarObjetivo" />

                <button type="button" class="btn-add-objetivo" :disabled="!novoObjetivo.trim()"
                  @click="adicionarObjetivo">
                  + Adicionar
                </button>
              </div>

              <div v-if="formData.objetivosEspecificos.length > 0" class="objetivos-lista">
                <div v-for="(obj, index) in formData.objetivosEspecificos.slice(
                  0,
                  5
                )" :key="obj.id || index" class="objetivo-tag" :title="obj.titulo">
                  <span class="objetivo-texto">
                    {{ obj.titulo }}
                  </span>

                  <button type="button" :disabled="!obj.deleteIsPossible" :class="obj.deleteIsPossible
                    ? 'objetivo-remover'
                    : 'objetivo-nao-remover'
                    " :title="obj.deleteIsPossible
                      ? 'Excluir objetivo'
                      : 'Esse objetivo não pode ser excluído, pois está vinculado a uma ou várias atividades!'
                      " @click="removerObjetivo(index, obj)">
                    ✕
                  </button>
                </div>

                <span v-if="formData.objetivosEspecificos.length > 5" class="objetivo-mais">
                  +{{ formData.objetivosEspecificos.length - 5 }} mais
                </span>
              </div>

              <p v-else-if="!modoEditar" class="objetivo-vazio">
                Nenhum objetivo cadastrado.
              </p>
            </div>
            <div class="campo-grupo">
              <GaleriaFotosAcao :acaoId="idAcao" :tituloAcao="acao.titulo" :coordenador="isCoordenadorDaAcao" />
            </div>
          </div>
        </div>
        <div v-if="modoEditar" class="preview-secao">
          <h4 class="preview-titulo">
            Preview do Card na Listagem
          </h4>

          <div class="conteudo-preview">
            <div class="imagem-conteudo-acao">
              <img v-if="imagemAtual" :src="imagemAtual" alt="Imagem da Ação" />

              <img v-else src="@/assets/logoGex1.2.png" alt="Logo GEX" />
            </div>

            <div class="conteudo-listagem-acao">
              <div class="cima-conteudo-acao">
                <h5>
                  {{ formData.titulo || "Sem título" }}
                </h5>

                <p class="descricao-texto">
                  <b>Descrição: </b>

                  {{
                    formData.descricao ||
                    "Sem descrição informada."
                  }}
                </p>
              </div>

              <div class="baixo-conteudo-acao">
                <p>
                  <b>Área Temática: </b>

                  {{
                    formData.areaTematica ||
                    "Não informada"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="modoEditar" class="info-acoes">
          <button type="button" class="btn-cancelar" @click="cancelarEdicao">
            Cancelar
          </button>

          <button type="button" class="btn-salvar" :disabled="salvando" @click="salvarAlteracoes">
            {{ salvando ? "Salvando..." : "Salvar Alterações" }}
          </button>
        </div>
      </div>
    </div>
    <ModalEditarSigla :mostrar="modalSiglaVisivel" :acaoId="idAcao" :siglaAtual="acao.sigla" :corAtual="acao.corSigla"
      @fechar="fecharModalSigla" @atualizado="onSiglaAtualizada" />
    <ModalFaleConosco :mostrar="modalFaleConoscoVisivel" :acaoId="idAcao" :tituloAcao="acao.titulo"
      @fechar="fecharModalFaleConosco" />
    <ModalMembrosEquipe :mostrar="modalMembrosVisivel" :acaoId="idAcao" :nomeAcao="acao.titulo"
      :imagemAcao="imagemAtual" @fechar="fecharModalMembros" />
    <EscolhaFormulario v-if="mostrarModalFormularios" @fecharModal="fecharModalFormularios"
      @formularioExterno="acessarFormularioExterno" @formularioInterno="acessarFormularioInterno" />
    <ModalDeConfirmacao
      v-if="confirmacaoObjetivo.mostrar"
      :texto="confirmacaoObjetivo.mensagem"
      @confirmacao="confirmarExclusaoObjetivo"
    />
    <Aviso
      v-if="aviso.mostrar"
      :sucesso="aviso.sucesso"
      :texto="aviso.mensagem"
      @fecharModal="aviso.mostrar = false"
    />
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  onBeforeUnmount,
  watch,
  reactive,
  computed,
  nextTick,
} from "vue";
import {
  useRoute,
  useRouter,
} from "vue-router";

import acaoService from "@/service/acaoService";
import objetivosService from "@/service/objetivosService";

import Carregamento from "@/components/common/Carregamento.vue";
import Aviso from "@/components/common/aviso.vue";
import ModalDeConfirmacao from "@/components/common/modalDeConfirmacao.vue";
import ModalEditarSigla from "@/components/acoes/ModalEditarSigla.vue";
import ModalFaleConosco from "@/components/ajuda/ModalFaleConosco.vue";
import ModalMembrosEquipe from "@/components/acoes/ModalMembrosEquipe.vue";
import EscolhaFormulario from "@/components/modals/EscolhaFormulario.vue";
import GaleriaFotosAcao from "@/components/acoes/GaleriaFotosAcao.vue";
import parceriaService from "@/service/parceriaService";

import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const props = defineProps({
  acaoId: {
    type: [String, Number],
    default: "",
  },

  id: {
    type: [String, Number],
    default: "",
  },
  isCoordenador: {
    type: Boolean,
    default: false,
  },
});

const idAcao = computed(() => {
  return (
    props.acaoId ||
    props.id ||
    route.params.id ||
    route.params.acaoId ||
    ""
  );
});

const usuarioAutenticado = ref(authStore.isAutenticado);

const parcerias = ref([]);
const carregandoParcerias = ref(false);
const carregando = ref(true);
const salvando = ref(false);
const modoEditar = ref(false);
const modalSiglaVisivel = ref(false);
const modalFaleConoscoVisivel = ref(false);
const modalMembrosVisivel = ref(false);
const mostrarModalFormularios = ref(false);
const isCoordenadorDaAcao = ref(false);
const inputImagem = ref(null);
const novoObjetivo = ref("");
const acao = ref({});
const aviso = reactive({
  mostrar: false,
  sucesso: true,
  mensagem: "",
});
const confirmacaoObjetivo = reactive({
  mostrar: false,
  index: -1,
  objetivo: null,
  mensagem: "",
});

function exibirAviso(mensagem, sucesso = true) {
  aviso.mensagem = mensagem;
  aviso.sucesso = sucesso;
  aviso.mostrar = true;
}
const formData = reactive({
  titulo: "",
  descricao: "",
  areaTematica: "",
  dataInicio: "",
  dataFim: "",
  imagemArquivo: null,
  imagemUrlPreview: null,
  objetivosEspecificos: [],
});
const imagemAtual = computed(() => {
  if (formData.imagemUrlPreview) {
    return formData.imagemUrlPreview;
  }

  if (acao.value?.imagemUrl) {
    return acao.value.imagemUrl;
  }

  if (acao.value?.imagem?.url) {
    return acao.value.imagem.url;
  }

  if (acao.value?.imagem?.base64Data) {
    return `data:${acao.value.imagem.mimeType || "image/png"
      };base64,${acao.value.imagem.base64Data}`;
  }

  return null;
});

let snapshot = {};
const textareaDescricao = ref(null);
function ajustarAlturaDescricao() {
  const el = textareaDescricao.value;

  if (!el) {
    return;
  }
  if (modoEditar.value) {
    el.style.height = "";
    return;
  }

  el.style.height = "auto";
  el.style.height = `${el.scrollHeight}px`;
}
watch(
  [carregando, modoEditar, () => formData.descricao],
  () => {
    nextTick(ajustarAlturaDescricao);
  },
  { flush: "post" }
);

window.addEventListener("resize", ajustarAlturaDescricao);

onBeforeUnmount(() => {
  window.removeEventListener("resize", ajustarAlturaDescricao);
});

async function carregarParceriasDaAcao() {
  const acaoId = idAcao.value;

  if (!acaoId || acaoId === "undefined") {
    parcerias.value = [];
    carregandoParcerias.value = false;
    return;
  }

  carregandoParcerias.value = true;

  try {
    const response =
      await parceriaService.listarParceriasExternasPorAcao(acaoId);

    const dados = response?.data ?? response;
    const lista = Array.isArray(dados) ? dados : [];

    parcerias.value = lista.map((parceria) => ({
      id: parceria.id,
      parceiro: normalizarNomeParceiro(parceria.nomeInstituicao),
      jaFormalizada:
        typeof parceria.jaFormalizada === "boolean"
          ? parceria.jaFormalizada
          : null,
    }));
  } catch (error) {
    console.error("Erro ao carregar parcerias da ação:", error);
    parcerias.value = [];
  } finally {
    carregandoParcerias.value = false;
  }
}
function normalizarNomeParceiro(nomeInstituicao) {
  if (!nomeInstituicao) {
    return "Não informado";
  }

  return String(nomeInstituicao)
    .replace(/[\uFFFD\u00BF?]/g, "-")
    .trim();
}

function traduzirFormalizacao(jaFormalizada) {
  if (jaFormalizada === true) {
    return "Formalizada";
  }

  if (jaFormalizada === false) {
    return "Não formalizada";
  }

  return "Não informado";
}

function abrirFormularioParceria() {
  if (!isCoordenadorDaAcao.value) {
    console.warn(
      "Usuário não é coordenador desta ação."
    );

    return;
  }

  if (!idAcao.value) {
    console.error(
      "Não foi possível identificar a ação para solicitar parceria."
    );

    return;
  }

  mostrarModalFormularios.value = true;
}
function fecharModalFormularios() {
  mostrarModalFormularios.value = false;
}
async function acessarFormularioExterno() {
  const acaoId = idAcao.value;

  if (!acaoId) {
    console.error(
      "Não foi possível navegar para parceria externa: ID da ação não encontrado."
    );

    return;
  }

  mostrarModalFormularios.value = false;

  try {
    await router.push({
      name: "formulario-parceria-externa",

      params: {
        id: acaoId,
        acaoId,
      },
    });
  } catch (error) {
    console.error(
      "Erro ao abrir formulário de parceria externa:",
      error
    );
  }
}
async function acessarFormularioInterno() {
  const acaoId = idAcao.value;

  if (!acaoId) {
    console.error(
      "Não foi possível navegar para parceria interna: ID da ação não encontrado."
    );

    return;
  }

  mostrarModalFormularios.value = false;

  try {
    await router.push({
      name: "formulario-parceria-interna",

      params: {
        id: acaoId,
        acaoId,
      },
    });
  } catch (error) {
    console.error(
      "Erro ao abrir formulário de parceria interna:",
      error
    );
  }
}

async function buscarDadosAcao() {
  const targetId = idAcao.value;

  if (!targetId || targetId === "undefined") {
    carregando.value = false;
    return;
  }

  isCoordenadorDaAcao.value = false;
  carregando.value = true;

  try {
    const response = await acaoService.getAcoesById(
      targetId
    );

    acao.value = response || {};

    sincronizarForm();
    if (authStore.isAutenticado) {
      try {
        const ehCoord =
          await acaoService.verificarCoordenador(
            targetId
          );

        isCoordenadorDaAcao.value = !!ehCoord;
      } catch (error) {
        console.error(
          "Erro ao verificar coordenador da ação:",
          error
        );

        isCoordenadorDaAcao.value = false;
      }
    } else {
      isCoordenadorDaAcao.value = false;
    }
  } catch (error) {
    console.error(
      "Erro ao buscar dados da ação:",
      error
    );
  } finally {
    carregando.value = false;
  }
}

function sincronizarForm() {
  formData.titulo = acao.value.titulo || "";
  formData.descricao = acao.value.descricao || "";
  formData.areaTematica =
    acao.value.areaTematica || "";

  formData.dataInicio =
    acao.value.dataInicio || "";

  formData.dataFim =
    acao.value.dataFim || "";

  formData.imagemArquivo = null;
  formData.imagemUrlPreview = null;

  formData.objetivosEspecificos =
    Array.isArray(acao.value.objetivos)
      ? acao.value.objetivos
        .map((objetivo) => {
          if (typeof objetivo === "string") {
            return {
              id: null,
              titulo: objetivo,
              deleteIsPossible: true,
            };
          }

          return {
            id:
              objetivo.id ||
              objetivo.uuid ||
              null,

            titulo:
              objetivo.titulo || "",

            deleteIsPossible:
              objetivo.deleteIsPossible !== false,
          };
        })
        .filter((objetivo) => objetivo.titulo)
      : [];
}

function adicionarObjetivo() {
  const texto = novoObjetivo.value.trim();

  if (!texto) {
    return;
  }

  formData.objetivosEspecificos.unshift({
    id: null,
    titulo: texto,
    deleteIsPossible: true,
  });

  novoObjetivo.value = "";
}

function removerObjetivo(index, obj) {
  if (!obj.id) {
    formData.objetivosEspecificos.splice(index, 1);
    return;
  }

  confirmacaoObjetivo.index = index;
  confirmacaoObjetivo.objetivo = obj;
  confirmacaoObjetivo.mensagem = `Deseja realmente excluir o objetivo "${obj.titulo}"?`;
  confirmacaoObjetivo.mostrar = true;
}

async function confirmarExclusaoObjetivo(confirmou) {
  const index = confirmacaoObjetivo.index;
  const obj = confirmacaoObjetivo.objetivo;
  confirmacaoObjetivo.mostrar = false;

  if (!confirmou || !obj) return;

  try {
    await objetivosService.deletarObjetivo(obj.id);
    formData.objetivosEspecificos.splice(index, 1);
    exibirAviso("Objetivo excluído com sucesso!", true);
  } catch (error) {
    console.error("Erro ao excluir objetivo:", error);
    exibirAviso("Erro ao excluir o objetivo. Tente novamente.", false);
  }
}

function ativarModoEditar() {
  snapshot = {
    ...formData,

    objetivosEspecificos:
      formData.objetivosEspecificos.map(
        (objetivo) => ({
          ...objetivo,
        })
      ),
  };

  modoEditar.value = true;
}

function cancelarEdicao() {
  Object.assign(formData, {
    ...snapshot,

    objetivosEspecificos: (
      snapshot.objetivosEspecificos || []
    ).map((objetivo) => ({
      ...objetivo,
    })),
  });

  novoObjetivo.value = "";
  modoEditar.value = false;
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };
  });
}

function onImagemSelecionada(event) {
  const file = event.target.files?.[0];

  if (!file) {
    return;
  }

  formData.imagemArquivo = file;

  formData.imagemUrlPreview =
    URL.createObjectURL(file);
}

function removerImagem() {
  formData.imagemArquivo = null;
  formData.imagemUrlPreview = null;

  if (acao.value) {
    acao.value.imagemUrl = null;

    if (acao.value.imagem) {
      acao.value.imagem = null;
    }
  }

  if (inputImagem.value) {
    inputImagem.value.value = "";
  }
}

async function salvarAlteracoes() {
  if (!formData.titulo.trim()) {
    exibirAviso("O título não pode estar vazio.", false);
    return;
  }

  if (!idAcao.value) {
    exibirAviso("Não foi possível identificar a ação.", false);
    return;
  }

  salvando.value = true;

  try {
    const payload = {
      titulo: formData.titulo,
      dataInicio: formData.dataInicio,
      dataFim: formData.dataFim,
      sigla: acao.value.sigla,
      corSigla: acao.value.corSigla,
      descricao: formData.descricao,
      areaTematica: formData.areaTematica,

      objetivos:
        formData.objetivosEspecificos.map(
          (objetivo) => {
            if (!objetivo.id) {
              return {
                id: null,
                titulo: objetivo.titulo,
                deleteIsPossible: true,
              };
            }

            return {
              id: objetivo.id,
              titulo: objetivo.titulo,
            };
          }
        ),
    };

    if (formData.imagemArquivo) {
      const base64Str =
        await fileToBase64(
          formData.imagemArquivo
        );

      payload.imagem = {
        mimeType:
          formData.imagemArquivo.type,

        base64Data: base64Str,

        creditosImagem:
          "Imagem da Ação",
      };
    }

    await acaoService.editarAcao(
      idAcao.value,
      payload
    );

    await buscarDadosAcao();

    modoEditar.value = false;

    exibirAviso("Alterações salvas com sucesso!", true);
  } catch (error) {
    console.error(
      "Erro ao salvar alterações:",
      error
    );

    exibirAviso(
      "Erro ao salvar alterações. Verifique sua conexão.",
      false
    );
  } finally {
    salvando.value = false;
  }
}

function abrirModalSigla() {
  modalSiglaVisivel.value = true;
}

function fecharModalSigla() {
  modalSiglaVisivel.value = false;
}

function onSiglaAtualizada() {
  modalSiglaVisivel.value = false;
  exibirAviso("Configurações da sigla atualizadas com sucesso!", true);
  buscarDadosAcao();
}

function abrirModalFaleConosco() {
  modalFaleConoscoVisivel.value = true;
}

function fecharModalFaleConosco() {
  modalFaleConoscoVisivel.value = false;
}

function abrirModalMembros() {
  modalMembrosVisivel.value = true;
}

function fecharModalMembros() {
  modalMembrosVisivel.value = false;
}

watch(idAcao, (novoId) => {
  modoEditar.value = false;
  isCoordenadorDaAcao.value = false;
  acaoService.limparCacheCoordenador(novoId);

  if (!novoId || novoId === "undefined") {
    parcerias.value = [];
    carregandoParcerias.value = false;
    return;
  }

  buscarDadosAcao();
  carregarParceriasDaAcao();
});

onMounted(() => {
  buscarDadosAcao();
  carregarParceriasDaAcao();
});
</script>

<style scoped>
.info-acao-container {
  width: 100%;
  padding: 24px 16px;
  font-family: var(--font-base);
  display: flex;
  justify-content: center;
}

.info-acao-wrapper {
  width: 100%;
  max-width: 100%;
}

.acesso-negado {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 64px 24px;
}

.mensagem-negada {
  text-align: center;
  color: var(--roxo-medio);
  max-width: 400px;
}

.mensagem-negada svg {
  color: var(--roxo-primario);
  margin-bottom: 16px;
  opacity: 0.8;
}

.mensagem-negada h3 {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 600;
  color: var(--roxo-escuro);
}

.mensagem-negada p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.info-titulo-secao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
}

.info-titulo-secao h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--roxo-escuro);
}

.botoes-topo {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-editar-principal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  background: var(--roxo-primario);
  color: var(--branco);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-base);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-editar-principal:hover {
  background: var(--roxo-medio);
}

.btn-editar-principal:active {
  transform: scale(0.98);
}

.btn-membros-equipe {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background: var(--roxo-primario);
  color: var(--branco);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-base);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-membros-equipe:hover {
  background: var(--roxo-medio);
}

.btn-membros-equipe:active {
  transform: scale(0.98);
}

.info-form {
  background: var(--branco);
  box-shadow: none !important;
}

.campos-grid {
  display: flex;
  justify-content: space-between;

  width: 100%;
}

.coluna-direita {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 55%;
}

.coluna-esquerda {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 40%;
}

.campo-grupo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.linha-datas {
  display: flex;
  gap: 16px;
  width: 100%;
}

.linha-datas .campo-grupo {
  flex: 1;
}

.campo-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--roxo-primario);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.campo-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid transparent !important;
  border-radius: 8px;
  font-size: 14px;
  font-family: var(--font-base);
  color: var(--preto);
  background-color: var(--branco) !important;
  box-sizing: border-box;
}

.campo-input:not(:disabled) {
  border-color: var(--roxo-claro) !important;

}

.campo-input:not(:disabled):focus {
  outline: none;
  border-color: var(--roxo-medio);
  box-shadow:
    0 0 0 3px hsla(258, 46%, 46%, 0.12);
}

.campo-input:disabled {
  cursor: auto;
  padding: 0px;
}

.imagem-preview-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.imagem-preview-img {
  width: 300px;
  height: 300px;
  object-fit: cover;
  border-radius: 8px;
}

.btn-excluir-foto {
  padding: 8px 14px;
  background-color: var(--vermelho-escuro);
  color: var(--branco);
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
  height: fit-content;
}

.btn-excluir-foto:hover {
  background-color: var(--vermelho);
}

.imagem-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--roxo-claro);
  background-color: var(--roxo-superficie);
  border: 1.5px dashed var(--roxo-claro);
  border-radius: 8px;
  height: 200px;
  width: 100%;
}

.imagem-upload-input-novo {
  width: 100%;
  padding: 8px;
  border: 1.5px solid var(--roxo-superficie);
  border-radius: 8px;
  background-color: var(--branco);
  font-family: var(--font-base);
  color: var(--cinza-escuro);
}

.campo-com-acao {
  display: flex;
  gap: 12px;
  align-items: center;
}

.campo-com-acao .campo-input {
  flex: 1;
}

.btn-campo-acao {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-base);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-campo-acao:hover {
  background: var(--roxo-primario);
  box-shadow:
    0 1px 3px 0 hsla(0, 0%, 0%, 0.1),
    0 1px 2px 0 hsla(0, 0%, 0%, 0.06);
}

.campo-coordenador-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.input-coordenador {
  flex: 1 1 auto;
  min-width: 0;
}

.btn-falar-coordenador {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--roxo-primario);
  color: var(--branco);
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: var(--font-base);
}

.btn-falar-coordenador:hover {
  background: var(--roxo-medio);
}

.btn-falar-coordenador:active {
  transform: scale(0.98);
}

.parcerias-acao-cabecalho {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  cursor: default;
}

.parcerias-acao-lista {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  cursor: default;
}

.parceria-acao-item {
  display: block;
  width: 100%;
  line-height: 1.5;
}

.parceria-acao-titulo {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--preto);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.formalizada,
.nao-formalizada {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;

  width: fit-content;
  max-width: max-content;

  margin: 0 0 0 6px;
  padding: 3px 8px;

  border-radius: 12px;

  font-size: 10px;
  line-height: 1.2;
  font-weight: 600;
  white-space: nowrap;
}

.formalizada {
  background: var(--roxo-medio);
  color: var(--branco);
  border: 1px solid var(--roxo-primario);
}

.nao-formalizada {
  background: var(--cinza-claro);
  color: var(--cinza-escuro);
  border: 1px solid var(--cinza-medio);
}

.parceria-acao-parceiro {
  font-size: 12px;
  line-height: 1.4;
  color: var(--roxo-primario);
  overflow-wrap: anywhere;
}

.parcerias-acao-carregando {
  padding: 12px 0;
  font-size: 13px;
  color: var(--cinza-medio);
  text-align: center;
}

.parcerias-acao-vazio {
  margin: 0;
  padding: 12px 14px;
  width: max-content;
  border: 1px dashed var(--roxo-superficie);
  border-radius: 8px;
  background: var(--cinza-claro);
  color: var(--cinza-medio);
  font-size: 13px;
  line-height: 1.5;
  font-style: italic;
}

/* Ajustes para telas menores */
@media (max-width: 480px) {
  .parceria-acao-item {
    align-items: flex-start;
    gap: 8px;
  }

  .parceria-acao-titulo {
    font-size: 13px;
  }

  #formalizada,
  #nao-formalizada {
    font-size: 10px;
    padding: 3px 7px;
  }
}

.info-acoes {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid var(--roxo-superficie);
}

.btn-salvar {
  padding: 12px 32px;
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-base);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-salvar:hover {
  background: var(--roxo-medio);
  box-shadow:
    0 1px 3px 0 hsla(0, 0%, 0%, 0.1),
    0 1px 2px 0 hsla(0, 0%, 0%, 0.06);
}

.btn-salvar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.campo-texto-leitura {
  margin: 0;
  font-size: 14px;
  font-family: var(--font-base);
  color: var(--preto);
  line-height: 1.5;
  white-space: normal;
  overflow-wrap: anywhere;
}

.btn-cancelar {
  padding: 12px 32px;
  background: transparent;
  color: var(--roxo-primario);
  border: 1.5px solid var(--roxo-primario);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-base);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-cancelar:hover {
  background: var(--roxo-superficie);
}

.preview-secao {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px dashed var(--roxo-superficie);
}

.preview-titulo {
  font-size: 12px;
  font-weight: 600;
  color: var(--cinza-medio);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 16px;
}

.conteudo-preview {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  box-shadow:
    0 1px 3px 0 hsla(0, 0%, 0%, 0.1);
  justify-content: space-between;
  align-items: center;
  background-color: var(--cinza-claro);
  border-radius: 0.5rem;
  padding: 24px 20px;
  width: 100%;
  pointer-events: none;
}

.conteudo-preview .imagem-conteudo-acao {
  height: 183px;
  width: 283px;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: var(--roxo-primario);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.conteudo-preview .imagem-conteudo-acao img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.conteudo-preview .conteudo-listagem-acao {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 183px;
  width: 100%;
  text-align: left;
  padding: 0 15px;
  color: var(--preto);
}

.conteudo-preview .cima-conteudo-acao h5 {
  font-size: 1.95rem;
  font-weight: 500;
  margin: 0 0 10px 0;
}

.conteudo-preview .cima-conteudo-acao p,
.conteudo-preview .baixo-conteudo-acao p {
  font-size: 15px;
  margin: 0;
}

.conteudo-preview .descricao-texto {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
  text-align: left;
  line-height: 1.4;
}

.objetivo-input-wrapper {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.objetivo-input {
  flex: 1;
  margin-bottom: 0 !important;
}

.btn-add-objetivo {
  flex-shrink: 0;
  padding: 0 16px;
  height: 40px;
  border-radius: 8px;
  border: 1.5px solid var(--roxo-primario);
  background: var(--branco);
  color: var(--roxo-primario);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-add-objetivo:hover:not(:disabled) {
  background: var(--roxo-primario);
  color: var(--branco);
}

.btn-add-objetivo:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.objetivos-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
}

.campo-textarea {
  resize: vertical;
  min-height: 250px;
  overflow-y: auto;
  line-height: 1.5;
}

.campo-textarea-leitura {
  min-height: 0;
  resize: vertical;
  overflow: hidden;
}

.objetivo-tag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: var(--roxo-superficie);
  border: 1px solid var(--roxo-superficie);
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow:
    0 1px 2px hsla(258, 53%, 28%, 0.06);
  transition: all 0.15s ease;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.objetivo-tag:hover {
  border-color: var(--roxo-claro);
  background: var(--roxo-superficie);
}

.objetivo-texto {
  font-size: 13px;
  color: var(--roxo-primario);
  font-weight: 500;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  display: block;
}

.objetivo-nao-remover,
.objetivo-remover {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: var(--roxo-superficie);
  color: var(--roxo-medio);
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  padding: 0;
}

.objetivo-nao-remover {
  cursor: not-allowed;
  opacity: 0.7;
}

.objetivo-remover:hover {
  background: var(--vermelho);
  color: var(--branco);
  box-shadow:
    0 1px 3px hsla(0, 72%, 51%, 0.35);
}

.objetivo-mais {
  font-size: 12px;
  color: var(--cinza-medio);
  font-style: italic;
  padding: 4px 0;
}

.objetivo-vazio {
  font-size: 13px;
  color: var(--cinza-medio);
  margin: 0;
  font-style: italic;
}

.descricao-vazia {
  font-size: 13px;
  color: var(--cinza-medio);
  margin: 0;
  font-style: italic;
}

@media (max-width: 768px) {

  .campos-grid {
    flex-direction: column;
  }

  .coluna-esquerda {
    width: 100%;
  }

  .coluna-direita {
    width: 100%;
  }

  .info-acao-container {
    padding: 16px 0px;
  }

  .info-titulo-secao {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .botoes-topo {
    width: 100%;
    flex-wrap: wrap;
  }

  .btn-editar-principal,
  .btn-membros-equipe {
    flex: 1;
    justify-content: center;
  }

  .campos-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .campo-com-acao {
    flex-direction: column;
    align-items: stretch;
  }

  .linha-datas {
    flex-direction: column;
  }

  .info-acoes {
    flex-direction: column-reverse;
  }

  .btn-salvar,
  .btn-cancelar {
    width: 100%;
    text-align: center;
    justify-content: center;
  }

  .campo-coordenador-container {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-falar-coordenador {
    justify-content: center;
  }

  .conteudo-preview {
    flex-direction: column;
    align-items: stretch;
  }

  .conteudo-preview .imagem-conteudo-acao {
    width: 100%;
  }

  .conteudo-preview .conteudo-listagem-acao {
    padding: 20px 0 0;
  }

  .objetivo-input-wrapper {
    flex-direction: column;
  }

  .btn-add-objetivo {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .imagem-preview-img {
    width: 100%;
  }

}
</style>
